import { isFeatureEnabled } from 'owa-feature-flags';
import { SERVICE_RESERVATION_ADAPTIVE_FEATURE } from 'owa-txp-common/lib/helpers/FeatureFlagName';

const txpGuid = '62242e1d-c39a-4f8a-a66e-1d39c0a336b0';

export default function isConnectorSenderDisabled(connectorSenderGuid: string) {
    // in the future we'll be probably be using the Outlook config API and this function will be removed
    return (
        !isFeatureEnabled(SERVICE_RESERVATION_ADAPTIVE_FEATURE) && connectorSenderGuid === txpGuid
    );
}
